import { syncVideoControls } from 'components/mediaControls/helpers';
import { MESSAGE_TYPE } from 'consts/enum';
import { onEscPress, removeElement } from 'helpers/helpers';
import { MediaPreviewTemplate } from './mediaPreview.template';

export default class MediaPreview {
	constructor(props) {
		this.initData(props);
		this.deletePrevInstance();
		this.initWrapper();
		this.initEventHandlers();
	}

	initData(propData = {}) {
		this.data = {};
		this.setter({
			...propData,
		});
	}

	deletePrevInstance() {
		const isDialogAlreadyInDOM = document.getElementById('engtMediaOverlay');
		if (isDialogAlreadyInDOM) {
			removeElement(isDialogAlreadyInDOM);
		}
	}

	initWrapper() {
		const wrapper = document.createElement('div');
		wrapper.className = 'engt-media-preview engt-media-controls-wrapper engt-open-preview';
		wrapper.id = 'engtMediaOverlay';
		wrapper.setAttribute('tabindex', 2);
		wrapper.innerHTML = MediaPreviewTemplate(this.data);

		this.previousFocusElement = document.activeElement;
		this.html = wrapper;
	}

	initEventHandlers() {
		this.html.querySelector('.engt-preview-close').addEventListener('click', this.onClose.bind(this));
		this.html.addEventListener('keydown', this.listenForEscape.bind(this));
	}

	onClose = () => {
		const { id } = this.data;

		if (this.data.type === MESSAGE_TYPE.VIDEO) {
			const media = document.getElementById('engtVideoExp');
			const origVideo = document.getElementById(`engtVideo-${id}`);
			syncVideoControls(origVideo, media, id);
			setTimeout(() => {
				removeElement(this.html);
			}, 300);
		} else {
			removeElement(this.html);
		}

		this.previousFocusElement?.focus?.();
	};

	listenForEscape = onEscPress(this.onClose);

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		document.getElementById('engtWrapper').appendChild(this.html);
		this.html.focus();
		return this.html;
	}
}
